export const center_app_version = {"commit_sha": "72e40490"}
